import APIClient, { NotFoundError } from '../lib/APIClient';
import Route from '../records/Route';
import { resolve } from '../helpers/LinkMapper';

const dataUrl = '/data/routes';
const routeCache = {};

const RouteService = {

    get (code) {
        if (routeCache[code]) {
            return routeCache[code];
        }

        routeCache[code] = APIClient.get(dataUrl + '/' + code)
            .then((response) => {
                if (response.result) {
                    return resolve({ ...response.result, id: dataUrl + '/' + code}).as(Route);
                }
                return new Route();
            })
            .catch((error) => {
                if (error instanceof NotFoundError) { return new Route(); }
                delete routeCache[code];
                throw error;
            });

        return routeCache[code];
    }
};

export default RouteService;



// WEBPACK FOOTER //
// ./src/services/RouteService.js